import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

export interface EmptyStateProps {
  icon?: IconName;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon = 'info', title, description, action }: EmptyStateProps) {
  return (
    <div style={{ textAlign: 'center', padding: 48, color: 'var(--muted)' }}>
      <div style={{ marginBottom: 12 }}>
        <Icon name={icon} size={32} color="var(--muted)" />
      </div>
      <h4 style={{ color: 'var(--text)', fontSize: 'var(--t-lg)', margin: '12px 0 4px', fontWeight: 600 }}>{title}</h4>
      {description && <p style={{ margin: '0 auto', maxWidth: 320, lineHeight: 1.55, fontSize: 'var(--t-sm)' }}>{description}</p>}
      {action && <div style={{ marginTop: 12 }}>{action}</div>}
    </div>
  );
}

export function Skeleton({ height = 16, width = '100%' }: { height?: number; width?: number | string }) {
  return (
    <span
      style={{
        display: 'inline-block',
        height,
        width,
        background: 'var(--surface-2)',
        borderRadius: 'var(--r-1)',
        animation: 'pulse 1.4s ease-in-out infinite',
      }}
    />
  );
}

export function SkeletonRows({ rows = 5 }: { rows?: number }) {
  return (
    <div className="stack">
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} height={20} />
      ))}
    </div>
  );
}
